import { PaginatedTable, TableProps } from '@app/components';
import { EtaRow } from './eta-row';
import { IETARowState } from '../types';

const TABLE_HEAD = [
  { id: 'taskName', label: 'Task Name', align: 'center' },
  { id: 'description', label: 'Description', align: 'center' },
  { id: 'expectedTime', label: 'Expected Time (hour)', align: 'center' },
  { id: 'actualTime', label: 'Actual Time (Hour)', align: 'center' },
  { id: 'status', label: 'Status', align: 'center', sortable: false },
];

interface Props {
  tableProps: TableProps;
  rows?: IETARowState[];
  loading: boolean;
}

const EtaList = ({ tableProps, rows, loading }: Props) => (
  <PaginatedTable<IETARowState>
    head={TABLE_HEAD}
    tableProps={tableProps}
    data={rows ?? []}
    loading={loading}
    isServerSidePaging={false}
  >
    {(row) => (
      <EtaRow
        row={row}
        selected={tableProps.selected.includes(row.id)}
        onSelectRow={() => {
          ('');
        }}
      />
    )}
  </PaginatedTable>
);
export { EtaList };
